module.exports = __webpack_public_path__ + "static/media/wepick.012ada67.svg";